class ProductQuickbuy extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.style = ``
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(document, 'click', this.handleClick)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      this.handleClose.bind(this),
    )
  }

  handleClick (event) {
    const target = event.target
    const closeEl =
      target.closest(this?.els?.overlay?.selector) ||
      target.closest(this?.els?.close?.selector)
    const triggerEl =
      target.closest(this?.externalEls?.trigger?.selector) ||
      target.closest('[data-product-quickbuy-external-el="trigger"]')

    if (closeEl) {
      this.handleClose()
    }

    if (triggerEl) {
      this.handleOpen()
      this.renderQuickbuy(triggerEl)
    }
  }

  handleOpen () {
    this.isHidden = false
  }

  handleClose () {
    this.isHidden = true
  }

  async renderQuickbuy (triggerEl) {
    const productUrl = triggerEl?.dataset?.productUrl
    if (!this.quickbuyEl || !productUrl) return

    const sectionHtmlFromCache = this.quickBuyCache[productUrl]

    if (!sectionHtmlFromCache) {
      this.quickbuyEl.setAttribute(this.busyAttribute, `true`)
      const sectionHTML = await this.getSectionHtml(productUrl)
      this.quickbuyEl.innerHTML = sectionHTML
      this.updateCache(productUrl, sectionHTML)
      this.quickbuyEl.setAttribute(this.busyAttribute, `false`)
    } else {
      this.quickbuyEl.innerHTML = sectionHtmlFromCache
    }
    this.refreshYotpoWidgets()
    // this.updateWishlistButton()
    this.dispatchEvent(
      new CustomEvent(`AFTER_QUICKBUY_RENDER`, {
        bubbles: true,
      }),
    )
  }

  async getSectionHtml (productUrl) {
    const html = await this.sectionRenderer.fetchSingle(
      this.sectionId,
      productUrl,
    )
    return this.sectionRenderer.getInnerHtml(html)
  }

  updateCache (productUrl, sectionHTML) {
    const cache = this.quickBuyCache
    cache[productUrl] = sectionHTML
    this.quickBuyCache = cache
  }

  refreshYotpoWidgets () {
    if (!window.yotpo?.initialized) return
    window.yotpo.refreshWidgets()
  }

  updateWishlistButton () {
    const wishlistAddButtonEl = window.BAO.Utils.getElement(
      `[data-wishlist-button-add]`,
      {
        context: this,
      },
    )
    const productId = wishlistAddButtonEl?.dataset?.product
    const variantId = wishlistAddButtonEl?.dataset?.variant
    wishlistAddButtonEl.classList.toggle(
      'iwishAdded',
      window.wishlist.isInWishlist(productId, variantId),
    )
  }

  set isHidden (boolean) {
    this.setAttribute(this.hiddenAttribute, boolean.toString())
    this.bodyEl.classList.toggle(`util-HideLiveChat`, !boolean)
  }

  get isHidden () {
    return this.getAttribute(this.hiddenAttribute) === `true`
  }

  get hiddenAttribute () {
    return `aria-hidden`
  }

  get busyAttribute () {
    return `aria-busy`
  }

  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }

  get sectionId () {
    return `product-quickbuy`
  }

  set quickBuyCache (object) {
    this._quickBuyCache = object
  }

  get quickBuyCache () {
    return this._quickBuyCache || {}
  }

  get overlayEl () {
    return this?.els?.overlay?.element
  }

  get quickbuyEl () {
    return this?.els?.quickbuy?.element
  }

  get triggerEls () {
    return this?.externalEls?.trigger?.elements
  }

  get bodyEl () {
    return window.BAO.Utils.getElement('body', document)
  }
}

if (!customElements.get('product-quickbuy')) {
  customElements.define('product-quickbuy', ProductQuickbuy)
}
